import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { BankAccount } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<BankAccount> | null>;

export interface Props extends RequestPagination {}

type GetAllSwrParams = [string, number, number];

const useGetBankAccounts = ({ pageNumber, pageSize }: Props): Return => {
  const fetcher = useSWR<PaginatedResponse<BankAccount>, Error, GetAllSwrParams>(
    [SWR_KEYS.getBankAccounts, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      t2payService.getBankAccounts({ pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetBankAccounts;
